var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navigation'),_c('transition',{attrs:{"name":"fade"}},[(_vm.alertBar.show)?_c('alert-bar'):_vm._e()],1),_c('main',[_c('div',{attrs:{"id":"wrapper"}},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }